<template>
    <work-order-datatable
        :request-id="props.requestId"
        :client-id="props.clientId"
        :hide-filters="props.hideFilters"
        :embedded="props.embedded"
        :disable-actions="props.disableActions"
    />
    <router-view name="modal"></router-view>
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import WorkOrderDatatable from "@/components/WorkOrders/WorkOrderDatatable.vue";

const props = defineProps({
    requestId: {
        type: [Number, String],
        default: null
    },
    clientId: {
        type: [Number, String],
        default: null
    },
    hideFilters: {
        type: Boolean,
        default: false
    },
    embedded: {
        type: Boolean,
        default: false
    },
    disableActions: {
        type: Boolean,
        default: false
    }
});
</script>
